import axios from 'axios';
import Qs from 'qs';
// import router from 'umi/router';

export const MethodType = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
  PATCH: 'PATCH',
};

const service = axios.create({
  timeout: 60000,
  withCredentials: true,
});

/**
 * 请求前拦截
 * 用于处理需要在请求前的操作
 */
service.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

/**
 * 请求响应拦截
 * 用于处理需要在请求返回后的操作
 */
service.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  },
);

const request = (method = MethodType.GET, api, params = {}, options = {}) => {
  const token = localStorage.getItem('token') || '';
  const headers = {
    ...(options.headers || {}),
    Authorization: token,
  };
  if (method === 'GET') {
    return new Promise((resolve, reject) => {
      service({
        url: api,
        method,
        params,
        headers,
      })
        .then(resolve)
        .catch((error) => {
          reject(error);
        });
    });
  } else if (method === 'POST') {
    return new Promise((resolve, reject) => {
      service({
        url: api,
        method,
        data: Qs.stringify(params),
        headers,
      })
        .then(resolve)
        .catch((error) => {
          reject(error);
        });
    });
  }
};

export default request;
